import { CreateService, CRUDServiceInterface } from '@/services/service';
import { SurveyQuestionResultEntity } from '@/entities/survey-question-result.entity';
import APIBuilder from '@quangphuc/frontend-api-builder';

export default class SurveyQuestionResultService
  extends CreateService<SurveyQuestionResultEntity>('survey-question-result')
  implements CRUDServiceInterface<SurveyQuestionResultEntity>
{
  async getMany(
    staffId: number,
    notifyId: number,
    companyId: number,
  ): Promise<SurveyQuestionResultEntity[]> {
    this.apiBuilder.reset()
    const [rows] = await this.apiBuilder
      .join(['surveyQuestion'])
      .filter('notifyId', '$eq', String(notifyId))
      .filter('staffId', '$eq', String(staffId))
      .filter('companyId', '$eq', String(companyId))
      .getMany();
    return rows;
  }

  async createMany(instances: {
    bulk: Partial<SurveyQuestionResultEntity>[];
  }): Promise<Partial<SurveyQuestionResultEntity>[]> {
    const { data } = await APIBuilder.axios.post<
      Partial<SurveyQuestionResultEntity>[]
    >(`${this.apiBuilder.$endpoint}/bulk`, instances);
    return data;
  }
}
